import { FunctionComponent } from "react";

import {
	confirmPlanOfTarget,
	useConfirmPreassigned,
} from "../../CampaignRouting/ConfirmPreassignedModal";
import { canConfirmPlan } from "../../CampaignRouting/utils/confirmEligibility";
import { ReachOutMenu } from "../../ReachOut/ReachOutMenu";
import { ReachOutBulkTarget } from "../../ReachOut/reachOutTarget";

interface BulkReachOutMenuProps {
	/** The footer button's rect while the menu is open, else null. */
	anchorRect: DOMRect | null;
	target: ReachOutBulkTarget | null | undefined;
	onClose: () => void;
	onRevertAssignedCampaign?: () => void;
	onRunAiSnippets?: () => void;
	/** The table's snackbar: the confirm result outlives its dialog. */
	showMessage: (message: string) => void;
}

/**
 * The unassigned table's bulk "Reach out" menu, anchored to the footer button, and the dialogs its
 * bulk-only items open that this component owns: "Confirm preassigned campaigns" (PREC-4219). The
 * dialog stays mounted when the menu closes, so it is rendered here rather than inside the menu.
 * The confirm is offered only when the selection holds a lead the server would confirm
 * (`canConfirmPlan`): the label and the action come from one classification of the rows.
 */
export const BulkReachOutMenu: FunctionComponent<BulkReachOutMenuProps> = ({
	anchorRect,
	target,
	onClose,
	onRevertAssignedCampaign,
	onRunAiSnippets,
	showMessage,
}) => {
	const confirmPreassigned = useConfirmPreassigned(showMessage);
	const canConfirm = !!target && canConfirmPlan(confirmPlanOfTarget(target));

	return (
		<>
			{anchorRect && target && (
				<ReachOutMenu
					anchorRect={anchorRect}
					target={target}
					onClose={onClose}
					onConfirmPreassigned={canConfirm ? () => confirmPreassigned.open(target) : undefined}
					onManual={onClose}
					onRevertAssignedCampaign={onRevertAssignedCampaign}
					onRunAiSnippets={onRunAiSnippets}
				/>
			)}
			{confirmPreassigned.modal}
		</>
	);
};
